module.exports = __webpack_public_path__ + "media/Images/icon-lock-secure-o-ba199b553f5165a8c7ee424aa309ea87.svg";